import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const bomApi = createApi({
  reducerPath: 'bomApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().user.token;
      if (token) {
        headers.set('authorization', token);
      }
      return headers;
    },
  }),
  tagTypes: ['BOM'],
  endpoints: (builder) => ({
    getBomList: builder.query({
      query: ({ limit = 10, offset = 0, search = '' }) => ({
        url: `/v1.0/external/bom/list`,
        params: { limit, offset, search },
      }),
      providesTags: ['BOM'],
    }),
    getBom: builder.query({
      query: (id) => `/v1.0/external/bom/${id}`,
      transformResponse: (response) => response.data,
      providesTags: ['BOM'],
    }),
    updateBom: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/v1.0/external/bom/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['BOM'],
    }),
    updateService: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/v1.0/external/service/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['BOM'],
    }),
  }),
});

export const {
  useGetBomListQuery,
  useGetBomQuery,
  useUpdateBomMutation,
  useUpdateServiceMutation,
} = bomApi; 